import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Hub } from '@aws-amplify/core';
import { AuthenticatorService,translations } from '@aws-amplify/ui-angular';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { I18n } from 'aws-amplify/utils';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';

I18n.putVocabularies(translations);
I18n.setLanguage('es');

I18n.putVocabularies({
  es: {
    'Sign in': 'Siguiente',
    'Reset Password': 'Restablecer contraseña',
    'Email': 'Correo electrónico',
    'Invalid verification code provided, please try again.': 'Código de verificación inválido, por favor intente nuevamente.',
  },
});

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
/**
 * Página de inicio de sesión basada en AWS Amplify.
 *
 * Escucha el evento de autenticación de Amplify, recupera el correo y los
 * tokens del usuario, los persiste en localStorage, carga las autorizaciones
 * del perfil y redirige al listado de barcos.
 */
export class LoginComponent implements OnInit {
  loading: boolean = false;
  errorOverlay: boolean = false;
  public formFields = {
    signIn: {
      username: {
        placeholder: 'grupomexicanodedesarrollo@gmail.com',
        isRequired: true,
        label: 'Email'
      },
      password: {
        placeholder: '**********',
        isRequired: true,
        label: 'Contraseña'
      },
    },
  };

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    public authenticator: AuthenticatorService,
    private localStorageServices: LocalStorageService,
  ) {
    if (this.authService.currentUserValue) {
      this.router.navigate(['/ship-list']);
    }
  }

  ngOnInit(): void {

    Hub.listen('auth', (data) => {
      if (data.payload.event === 'signedIn') {
        this.loading = true;
        this.getEmail();
      }
    });
  }

  async getEmail() {
    try {
      const user = await getCurrentUser();
      const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};
      this.authService.idToken = idToken?.toString() || '';
      const userEmail = user.signInDetails?.loginId;
      this.localStorageServices.saveData('userEmail', userEmail);
      let tokenData: any = accessToken;
      tokenData = idToken || '';
      tokenData.payload.jwtToken = idToken?.toString() || '';
      this.authService.updateUserValue(tokenData.payload);
      this.saveAuthorizations();
    } catch (err) {
    }
  }

  saveAuthorizations() {
    this.authService.getAuthorizations()
    .subscribe( response => {
      if (typeof response !== 'object') {
        return;
      }
      // Eliminar de menu_options importacion(Id: 2)
      if (Array.isArray(response.menu_options)) {
        response.menu_options = response.menu_options.filter((option: any) => option.menu_id !== 2);
      } else {
        response.menu_options = [];
        response.reports = [];
      }
      this.localStorageServices.saveData('authorizations', response);
      this.loading = false;
      this.router.navigate(['/ship-list']);
    }, error => {
      this.loading = false;
      this.errorOverlay = true;
      setTimeout(() => {
        this.errorOverlay = false;
        this.authService.logout();
      }, 3000);
    });
  }

}
